import * as types from './types';

const initialState = {
  loading: false,
  conversations: [],
  currentPage: 1,
  unreadMessages: {
    loading: false,
    loaded: false,
    count: 0,
  },
};

const conversationReducer = (state = initialState, { type, payload, errors }) => {
  switch (type) {
    case types.CONVERSATIONS_LOAD_ONE:
      const existingConversations = state.conversations;
      const index = existingConversations.findIndex(
        (conversation) => conversation.id === payload.id,
      );

      if (index === -1) {
        existingConversations.push(payload);
      } else {
        existingConversations[index] = payload;
      }

      return {
        ...state,
        conversations: existingConversations,
      };
    case types.CONVERSATIONS_PAGINATION_LOAD_SUCCESS:
      return {
        ...state,
        nextPage: payload.next_page,
        totalPages: payload.total_pages,
        currentPage: payload.current_page,
      };
    case types.CONVERSATIONS_LOAD_START:
      return {
        ...state,
        loading: true,
      };
    case types.CONVERSATIONS_LOAD_SUCCESS:
      let conversations;
      if (state.currentPage != 1) {
        conversations = [...state.conversations, ...payload];
      } else {
        conversations = payload;
      }
      return {
        ...state,
        conversations: conversations,
        loading: false,
      };
    case types.CONVERSATIONS_LOAD_FAILURE:
      return {
        ...state,
        loading: false,
      };

    case types.CONVERSTATIONS_UNREAD_MESSAGES_LOAD_START:
      return {
        ...state,
        unreadMessages: {
          ...state.unreadMessages,
          loading: true,
        },
      };

    case types.CONVERSATIONS_SET_UNREAD_COUNT:
      return {
        ...state,
        unreadCount: payload,
        unreadMessages: {
          count: payload,
          loading: false,
          loaded: true,
        },
      };

    case types.CONVERSATIONS_UNREAD_MESSAGES_LOAD_FAILURE:
      return {
        ...state,
        unreadMessages: { count: undefined, loading: false, loaded: true },
      };

    default:
      return state;
  }
};

export default conversationReducer;
